import React from 'react';
import CreateIcon from "@mui/icons-material/Create";
import {IconButton} from "@mui/material";
import {Check} from "@mui/icons-material";
import type {Theme} from "@mui/material";
import classNames from "classnames";

const confirmButtonSx = {
  '&.MuiIconButton-root': {
    backgroundColor: "#3F51B514",
    padding: '0.29rem',
  },
} as const;

const confirmIconSx = (theme: Theme) => ({
  '&.MuiSvgIcon-root': {
    fontSize: '1.43rem',
    fill: theme.palette.secondary.main,
  },
});

interface EditToggleButtonProps {
  open: boolean;
  onClick: (open: boolean, event: React.MouseEvent) => void;
  className?: string;
}

const EditToggleButton = (props: EditToggleButtonProps) => {
  const {open, onClick, className} = props;

  const handleToggle = (event: React.MouseEvent) => {
    onClick(!open, event);
  };

  return <IconButton onClick={handleToggle} aria-label={open ? 'confirm' : 'edit'} color={'secondary'}
                     className={classNames(className)} sx={open ? confirmButtonSx : undefined} size={'small'}>
    {open ? <Check fontSize={'small'} sx={confirmIconSx}/> : <CreateIcon fontSize={'small'}/>}
  </IconButton>
};

export default EditToggleButton;
